import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar-with-spinner',
  templateUrl: './snackbar-with-spinner.component.html',
  styleUrls: ['./snackbar-with-spinner.component.scss'],
})
export class SnackbarWithSpinnerComponent implements OnInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; closeBtnText: string },
    public snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {}
}
